import { useForm, Form } from "../../components/form/useForm";
import Input from "../../components/controls/Input";

import { Box } from "@mui/material";

import useStyles from "./changePasswordStyle";
import { useTranslation } from "react-i18next";

import Button from "../../components/controls/Button";

import PageTitle from "../../components/pageTitle/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";

import ShowAlerts from "../../components/alert/Alert";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";

import globalStyles from "../../style/global.js";
import { changePasswordData } from "../../redux/reduser/changePassword";
function ChangePassword() {
  const classes = useStyles();
  const globalClasses = globalStyles();
  const { response, loading, error, errorMsg } = useSelector(
    (state) => state.changePassword
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const { t } = useTranslation();

  const initialFValues = {
    oldPassword: "",
    newPassword: "",

    confirmPassword: "",
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("oldPassword" in fieldValues)
      temp.oldPassword = fieldValues.oldPassword ? "" : t("required");
    if ("newPassword" in fieldValues)
      temp.newPassword = fieldValues.newPassword
        ? fieldValues.newPassword === fieldValues.confirmPassword
          ? ""
          : t("passwordDoesNotMatch")
        : t("required");

    if ("confirmPassword" in fieldValues)
      temp.confirmPassword = fieldValues.confirmPassword ? "" : t("required");
    if ("confirmPassword" in fieldValues)
      temp.confirmPassword = fieldValues.confirmPassword
        ? fieldValues.confirmPassword != fieldValues.newPassword
          ? t("passwordDoesNotMatch")
          : ""
        : t("required");

    setErrors({
      ...temp,
    });
          
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (validate()) {
      dispatch(changePasswordData(values))
        .unwrap()
        .then(() => {
          if (!error) {
            resetForm();
            setOpen(true);
          } else {
            setOpen(true);
          }
        })
        .catch(() => {
          setOpen(true);
        });
    }
  };

  return (
    <div>
      <ShowAlerts
        open={open}
        handleClose={handleClose}
        type={error ? "error" : "success"}
        msg={error ? errorMsg : response.message}
      />
      {loading ? (
        <div className={globalClasses.center}>
          <CircularProgressBar />
        </div>
      ) : null}
      <Form className={globalClasses.form}>
        <Box className={classes.box}>
          <Input
            name="oldPassword"
            label={t("oldPassword")}
            value={values.oldPassword}
            type={"password"}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.oldPassword}
          />
        </Box>
        <Box className={classes.box}>
          <Input
            name="newPassword"
            label={t("newPassword")}
            type={"password"}
            value={values.newPassword}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.newPassword}
          />
        </Box>

        <Box className={classes.box}>
          <Input
            name="confirmPassword"
            label={t("confirmPassword")}
            value={values.confirmPassword}
            type={"password"}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.confirmPassword}
          />
        </Box>
        <Box className={classes.box}>
          <p />
        </Box>
        <Box className={classes.box}>
          <Button
            className={globalClasses.btn}
            fullWidth="200px"
            color="primary"
            disabled={false}
            onClick={resetForm}
            text={t("reset")}
          />
        </Box>
        <Box className={classes.box}>
          <Button
            className={globalClasses.btn}
            fullWidth="200px"
            variant="contained"
            color="primary"
            disabled={false}
            onClick={handleSubmit}
            type="submit"
            text={t("submit")}
          />
        </Box>
      </Form>
    </div>
  );
}

export default ChangePassword;
